module.exports = __webpack_public_path__ + "static/media/image (20).4978031a.jpg";